module.exports = __webpack_public_path__ + "static/media/BankDetailTracking.4cf6eaad.svg";